import React, { useEffect, useState, useRef } from 'react';
import { reportsDialogCss } from './ReportsDialogCss';
import { withRouter, useHistory } from 'react-router-dom';
import {
    DialogTitle, DialogContent, DialogActions, Dialog
} from '@material-ui/core';
import { Document, Page, pdfjs } from 'react-pdf';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import ImageIcon from '../ImageIcon';
import { connect } from "react-redux";
import Button from '@material-ui/core/Button';
import FilterComponent from '../FilterComponent/FilterComponent';
import TripStatusFilter from '../FilterComponent/TripStatusFIlter';
import DateFilter from '../FilterComponent/DateFilter';
import CustomDateFilterDialog from '../FilterComponent/CustomDateFilter';
import PartySupplierFilter from '../FilterComponent/PartySupplierFilter';
import DocumentBookPdfFilter from '../FilterComponent/DocumentBookPdfFilter';
import * as logger from "../../../logger";
import { getAllPnlMonths, getPNLPerMonth, getAllParties, getSinglePartyPDFReport, getAllVendors, getSingleVendorPDFReport } from '../../../store/actions/homeActionCreator';
import { vehicleTripPNLMonthlyList, vehicleTripPNLMonthlyPDF, getVehicleDocumentPDF, vehicleMonthlyPnlReportPDF, vehcileMonthlyPnlReportV2, vehcileMonthlyPnlReportPdf, truckIncomeExcel, getSingleDriverKhatPdf } from '../../../store/actions/vehicleActionCreator';
import { getTripPdf, getInvoicePdf } from '../../../store/actions/tripActionCreator';
import { profitLossPdfV2, downloadProfitLossPdfV2, pnlReportExcel, supplierLegerPdfV2, supplierLegerPdfDownloadV2, partyLegerPdfV2, partyLegerPdfDownloadV2, partyBalanceExcel, supplierBalanceExcel, getSingleShopKhataPdf, updateChatView } from '../../../store/actions/userActionCreators';
import { getTripStartDateFilterValues, getRequestTimeInMillis, getDateFilterValueForMonthlyBalance, getEpochForSpecificMonth, getMilliDatePickerDateInStringDDMMMYYYY } from "../../../utils/utils";
import {
    TRIP_FILTER_STATUS,
    TRIP_FILTER_STATUS_MAPPING,
} from "../../../store/constants";
import { trackDwebEvent } from '../../analytics';
import { SizeMe } from 'react-sizeme';
import { ExcelIconBlack, PdfIconWhite } from '../../../components/icons';

const ReportsDialog = ({

    // Using this variable incase many default values need to be passed from components .
    defaultValueObject,
    // *********************

    open,
    user,
    trip,
    vehicle,
    location,
    pdfMonth,
    vehicleNumberValue,
    reportType,
    tripIdFromPartySummary,
    truckType,
    onClose,
    name,
    invoiceId,
    fromDocumentBook,
    doNotShowExcelButton,
    dispatchGetDocumentsPDF,
    vehicleIdValue,
    pdfFilterValue,
    defaultDocumentFilterValueName,
    defaultDocumentFilterValueType,
    dispatchTripBookPdf,
    dispatchGetPnlMonths,
    dispatchGetTripPnlMonths,
    dispatchGetAllParties,
    dispatchGetSinglePartyPDFReportAction,
    dispatchGetAllVendors,
    dispatchGetSingleVendorPDFReportAction,
    dispatchGetMonthlyProfitLossPDF,
    fromSinglePartyPage,
    partyIdFromSingleParty,
    monthDate,
    monthStartEpochValue,
    monthEndEpochValue,
    fromSingleSupplierPage,
    vendorIdFromSingleSupplier,
    dispatchGetTripPdf,
    dispatchGetTruckMonthlyPnlV2,
    dispatchVehcileMonthlyPnlReportPdf,
    dispatchGetTruckIncomeExcel,
    fromProfileReports,
    fromPartyIncomeReport,
    partyIdFromPartyIncomeReport,
    dispatchGetPnlPdf,
    dispatchProfiLossReportDownload,
    dispatchDownloadPnlExcel,
    dispatchGetSupplierLedgerPdf,
    dispatchSupplierLedgerPdfDownload,
    dispatchGetPartyLedgerPdf,
    dispatchPartyLedgerPdfDownload,
    dispatchPartyBalanceExcel,
    dispatchSupplierBalanceExcel,
    dispatchGetInvoicePdf,
    fromSingleDriverPage,
    driverIdFromSingleDriver,
    dispatchGetSingleDriverKhatPdf,
    shopIdFromSingleShop,
    fromSingleShopPage,
    dispatchGetSingleShopKhataPdf,
    dispatchChatView
}) => {

    // ************************************* State variables *************************************
    const focusPdf = React.createRef();
    const [dialogOpen, setDialogOpen] = useState(open);
    const [dateValue, setDateValue] = useState("");
    const [pdfWidth, setPdfWidth] = useState(document.body.clientWidth - 35);
    const [numPages, setNumPages] = useState(null);
    const [reportData, setReportData] = useState({});
    const [tripStatus, setTripStatus] = useState("ACTIVE");
    const [dateFilterValue, setDateFilterValue] = useState("ALL_MONTHS");
    const [customer, setCustomer] = useState([]);
    const [changeDataFlag, setChangeDataFlag] = useState(false);
    const [startDateRange, setStartDateRange] = useState({});
    const [showTripStatusFilter, setShowTripStatusFilter] = useState((fromSinglePartyPage || fromSingleSupplierPage) ? false : true);
    const [documentFilterKeyValue, setDocumentFilterKeyValue] = useState("");
    const [customFilter, setCustomFilter] = useState(false);
    const [customFilterValue, setCustomFilterValue] = useState({});
    const [docCount, setDocCount] = useState(1);
    // *****************************************************


    const title = location.state && location.state.pageTitle ? location.state.pageTitle : ""
    var dateFilterValues = getTripStartDateFilterValues();

    var pageTitleValue = location && location.state && location.state.pageTitle ? location.state.pageTitle : "";

    let singleTruck = vehicle.singleTruck ? vehicle.singleTruck : "";


    // *********************************************** Setting Default Values if required ***********************************************
    useEffect(() => {

        dispatchChatView(false)

        if (defaultValueObject && defaultValueObject.tripStatusFilter) {
            setTripStatus(defaultValueObject.tripStatusFilter);
        }

        if (defaultValueObject && defaultValueObject.dateFilterStatus) {
            setDateFilterValue(defaultValueObject.dateFilterStatus);
        }

        if (defaultValueObject && defaultValueObject.customDateRange) {
            setCustomFilterValue(defaultValueObject.customDateRange);
        }

    }, [defaultValueObject])
    //  *******************************************




    // ************************************************ Calling initial APIs required for respective flows ************************************************
    useEffect(() => {

        if (name == "Export Party Ledger Report" || fromPartyIncomeReport) {
            let requestData = {
                customer: [],
                fleetOwnerId: user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                getCustomersOnlyWithBalance: false,
                getTripsOnlyWithBalance: false,
                startDateRange: dateFilterValues[dateFilterValue]["startDateRange"],
                status: TRIP_FILTER_STATUS_MAPPING[tripStatus],
                defaultStatus: true
            }

            if (fromSinglePartyPage) {
                requestData.customer = [Number(partyIdFromSingleParty)];
            }

            if (fromPartyIncomeReport) {
                requestData.customer = [Number(partyIdFromPartyIncomeReport)];
                if (pdfMonth) {
                    const filterValue = getEpochForSpecificMonth(pdfMonth);
                    requestData.startDateRange = filterValue
                }
            }

            dispatchGetAllParties({},
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Reports Dialog Dweb", "Get all Parties successfull");
                        dispatchGetSinglePartyPDFReportAction(
                            requestData,
                            (data) => {
                                if (fromSinglePartyPage) {
                                    trackDwebEvent('Dweb Single Party PDF', {
                                        party_id: Number(partyIdFromSingleParty),
                                        party_name: title
                                    })
                                }
                                if (fromProfileReports) {
                                    trackDwebEvent("Dweb Profile Party PDF", {});
                                }
                                setShowTripStatusFilter(true);
                                if (data && data.status && data.status.code == 200) {
                                    logger.log("Reports Dialog Dweb", "Get Single Party PDF Successfull");
                                    setTripStatus(data.response && data.response.defaultFilterApplied ? "ACTIVE" : "ALL");
                                }
                            },
                            () => {
                                logger.log("Reports Dialog Dweb", "Get Single Party PDF Failed");
                                setShowTripStatusFilter(true);
                                setTripStatus("ACTIVE");
                            }
                        )

                    }
                },
                () => {
                    logger.log("Reports Dialog Dweb", "Get all Parties failed");
                }
            )
        } else

            if (name == "Export Supplier Ledger Report") {

                let requestData = {
                    vendors: [],
                    fleetOwnerId: user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                    startDateRange: dateFilterValues[dateFilterValue]["startDateRange"],
                    status: TRIP_FILTER_STATUS_MAPPING[tripStatus],
                    defaultStatus: true
                }

                if (fromSingleSupplierPage) {
                    requestData.vendors = [Number(vendorIdFromSingleSupplier)];
                }

                dispatchGetAllVendors({},
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log("Reports Dialog Component", "Get all Vendors Successfull");
                            dispatchGetSingleVendorPDFReportAction(
                                requestData,
                                (data) => {
                                    logger.log("Reports Dialog Component", "Get single vendor pdf successfull");
                                    if (vendorIdFromSingleSupplier) {
                                        trackDwebEvent("Dweb Single Suppler PDF", {
                                            "supplier_id": vendorIdFromSingleSupplier,
                                            "supplier_name": pageTitleValue
                                        })
                                    } else {
                                        trackDwebEvent("Dweb Profile Supplier PDF", {});
                                    }
                                    setShowTripStatusFilter(true);
                                    if (data && data.status && data.status.code == 200) {
                                        logger.log("Reports Dialog Dweb", "Get Single Party PDF Successfull");
                                        setTripStatus(data.response && data.response.defaultFilterApplied ? "ACTIVE" : "ALL");
                                    }
                                },
                                () => {
                                    logger.log("Reports Dialog Component", "Get single vendor pdf failed");
                                    setShowTripStatusFilter(true);
                                    setTripStatus("ALL");
                                }
                            )
                        }
                    },
                    () => {
                        logger.log("Reports Dialog Component", "Get all Vendors Failed");
                    }
                );
            } else

                if (name == "Monthly Balance Tab") {
                    let requestData = {
                        customer: partyIdFromSingleParty ? [Number(partyIdFromSingleParty)] : "",
                        fleetOwnerId: user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                        getCustomersOnlyWithBalance: false,
                        getTripsOnlyWithBalance: false,
                        startDateRange: {
                            startTimeEpoch: monthStartEpochValue,
                            endTimeEpoch: monthEndEpochValue
                        },
                        status: TRIP_FILTER_STATUS_MAPPING[tripStatus],
                        defaultStatus: true,
                    }

                    dispatchGetPnlMonths({},
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log("Reports Dialog Dweb", "Get PNL months successfull");
                                dispatchGetSinglePartyPDFReportAction(
                                    requestData,
                                    (data) => {
                                        logger.log("Reports Dialog Dweb", "Get Single Party PDF Successfull");
                                        setShowTripStatusFilter(true);
                                        if (data && data.status && data.status.code == 200) {
                                            logger.log("Reports Dialog Dweb", "Get Single Party PDF Successfull");
                                            setTripStatus(data.response && data.response.defaultFilterApplied ? "ACTIVE" : "ALL");
                                        }
                                    },
                                    () => {
                                        logger.log("Reports Dialog Dweb", "Get Single Party PDF Failed");
                                        setShowTripStatusFilter(true);
                                        setTripStatus("ALL");
                                    }
                                )
                            }
                        },
                        () => {
                            logger.log("Reports Dialog Dweb", "Get PNL months failed");
                        }
                    );

                } else if (name == "Trip Profit & Loss Report") {
                    dispatchGetTripPnlMonths({ vehicleId: Number(vehicleIdValue) },
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log("Reports Dialog Component Dweb", "Get Trip PNL months successfull");
                                setDateValue(data.response.months[0]);
                                dispatchTripBookPdf({
                                    vehicleId: Number(vehicleIdValue),
                                    month: data.response.months[0]
                                },
                                    (data) => {
                                        if (data && data.status && data.status.code == 200) {
                                            logger.log("Reports Dialog Component Dweb", "Get Trip Book successfull");
                                        }
                                    },
                                    () => {
                                        logger.log("Reports Dialog Component Dweb", "Get Trip Book failed");
                                    }
                                )
                            }
                        },
                        () => {
                            logger.log("Reports Dialog Component Dweb", "Get Trip PNL months failed");
                        }
                    )
                } else
                    if (name == "Document Book") {
                        dispatchGetDocumentsPDF({
                            vehicleId: Number(vehicleIdValue),
                            documentTypes: defaultDocumentFilterValueType == 'all_document' ? [] : [defaultDocumentFilterValueType]
                        },
                            (data) => {
                                if (data && data.status && data.status.code == 200) {

                                    logger.log("Reports Dialog Component Dweb", 'Document PDF Fetch Successfull');
                                }
                            },
                            () => {
                                logger.log("Reports Dialog Component Dweb", 'Document PDF Fetch Failed');
                            });
                    } else
                        if (name == "Truck Monthly Profit & Loss") {

                            let requestData = {
                                vehicleId: vehicleIdValue,
                                month: pdfMonth ? pdfMonth : ""
                            }

                            dispatchGetTripPnlMonths({ vehicleId: Number(vehicleIdValue) },
                                (data) => {
                                    if (data && data.status && data.status.code == 200) {
                                        logger.log("Reports Dialog Component Dweb", "Get Vehicle PNL months successfull");
                                        dispatchGetMonthlyProfitLossPDF(requestData,
                                            (data) => {
                                                if (data && data.status && data.status.code == 200) {
                                                    logger.log("Reports Dialog Component Dweb", 'Get truck Monthly PandL successfull');
                                                }
                                            },
                                            () => {
                                                logger.log("Reports Dialog Component Dweb", 'Get truck Monthly PandL failed');
                                            }
                                        );
                                    }
                                },
                                () => {
                                    logger.log("Reports Dialog Component Dweb", "Get Vehicle PNL months failed");
                                }
                            );
                        } else
                            if (name == "Trip Bill") {

                                dispatchGetTripPdf(tripIdFromPartySummary,
                                    (data) => {
                                        if (data && data.status && data.status.code == 200) {
                                            logger.log("Reports Dialog Dweb", 'Get Trip Pdf Successfull');
                                        }
                                    },
                                    () => {
                                        logger.log("Reports Dialog Dweb", 'Get Trip Pdf Failed');
                                    }
                                )

                            } else
                                if (name == "Truck Monthly Profit and Loss Report") {

                                    const filterData = {
                                        "month_year": pdfMonth ? pdfMonth : ""
                                    }

                                    dispatchGetPnlMonths({},
                                        (data) => {
                                            if (data && data.status && data.status.code == 200) {
                                                logger.log("Reports Dialog Dweb", "Get PNL months successfull");
                                                dispatchGetTruckMonthlyPnlV2(vehicleIdValue, filterData,
                                                    (data) => {
                                                        if (data && data.status && data.status.code == 200) {
                                                            logger.log("Reports Dialog Dweb", "Get Truck Monthly PNL V2 successfull");
                                                            if (data && data.response && data.response.pdfId) {
                                                                const pdfData = {
                                                                    pdfId: data.response.pdfId
                                                                }
                                                                dispatchVehcileMonthlyPnlReportPdf(vehicleIdValue, pdfData,
                                                                    () => {
                                                                        logger.log("Reports Dialog Dweb", "Pdf link fetched successfull");
                                                                    },
                                                                    () => {
                                                                        logger.log("Reports Dialog Dweb", "Pdf link fetched failed");
                                                                    }
                                                                );
                                                            }
                                                        }
                                                    },
                                                    () => {
                                                        logger.log("Reports Dialog Dweb", "Get Truck Monthly PNL V2 failed");
                                                    }
                                                )
                                            }
                                        },
                                        () => {
                                            logger.log("Reports Dialog Dweb", "Get PNL months failed");
                                        }
                                    );
                                } else
                                    if (name == "Profit and Loss Report") {

                                        const filterData = {
                                            "month_year": pdfMonth ? pdfMonth : ""
                                        };
                                        dispatchGetPnlPdf(filterData,
                                            (data) => {
                                                if (data && data.status && data.status.code == 200) {
                                                    logger.log('Reports Dialog Dweb', 'Get Profit Loss Report Pdf Successfull');
                                                    if (data && data.response && data.response.pdfId) {
                                                        const pdfData = {
                                                            "pdfId": data.response.pdfId
                                                        }
                                                        dispatchProfiLossReportDownload(pdfData,
                                                            (data) => {
                                                                if (data && data.status && data.status.code == 200) {
                                                                    logger.log('Reports Dialog Dweb', 'Get Profit Loss Report S3 Link Successfull');
                                                                    trackDwebEvent("Dweb Profit and Loss Report PDF view", {
                                                                        default_month: pdfMonth ? pdfMonth : ""
                                                                    });
                                                                }
                                                            },
                                                            () => {
                                                                logger.log('Reports Dialog Dweb', 'Get Profit Loss Report S3 Link failed');
                                                            }
                                                        )
                                                    }
                                                }
                                            },
                                            () => {
                                                logger.log('Reports Dialog Dweb', 'Get Profit Loss Report Pdf Successfull');
                                            }
                                        );

                                    } else
                                        if (name == "Supplier Ledger") {

                                            let requestData = {
                                                vendors: defaultValueObject && defaultValueObject.entityIds ? defaultValueObject.entityIds : [],
                                                fleetOwnerId: user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                                                startDateRange: dateFilterValues[defaultValueObject && defaultValueObject.dateFilterStatus ? defaultValueObject.dateFilterStatus : "ALL_MONTHS"]["startDateRange"],
                                                status: TRIP_FILTER_STATUS_MAPPING[defaultValueObject && defaultValueObject.tripStatusFilter ? defaultValueObject.tripStatusFilter : "ACTIVE"],
                                                defaultStatus: false
                                            }

                                            if (defaultValueObject && defaultValueObject.customDateRange && defaultValueObject.customDateRange.startTimeEpoch) {
                                                requestData.startDateRange = {
                                                    startTimeEpoch: defaultValueObject.customDateRange.startTimeEpoch,
                                                    endTimeEpoch: defaultValueObject.customDateRange.endTimeEpoch
                                                }
                                            }

                                            dispatchGetAllVendors({},
                                                (data) => {
                                                    if (data && data.status && data.status.code == 200) {
                                                        logger.log("Reports Dialog Component", "Get all Vendors Successfull");
                                                        dispatchGetSupplierLedgerPdf(requestData,
                                                            (data) => {
                                                                setShowTripStatusFilter(true);
                                                                if (data && data.status && data.status.code == 200) {
                                                                    logger.log('Reports Dialog Dweb', 'Get Supplier Ledger Report Pdf Successfull');
                                                                    if (data && data.response && data.response.pdfId) {
                                                                        const pdfData = {
                                                                            "pdfId": data.response.pdfId
                                                                        }
                                                                        dispatchSupplierLedgerPdfDownload(pdfData,
                                                                            (data) => {
                                                                                if (data && data.status && data.status.code == 200) {
                                                                                    logger.log('Reports Dialog Dweb', 'Get Supplier Ledger Report S3 Link Successfull');
                                                                                }
                                                                            },
                                                                            () => {
                                                                                logger.log('Reports Dialog Dweb', 'Get Supplier Ledger Report S3 Link failed');
                                                                            }
                                                                        )
                                                                    }
                                                                }
                                                            },
                                                            () => {
                                                                logger.log('Reports Dialog Dweb', 'Get Supplier Ledger Report Pdf Failed');
                                                                setShowTripStatusFilter(true);
                                                                setTripStatus("ALL");
                                                            }
                                                        )
                                                    }
                                                },
                                                () => {
                                                    logger.log("Reports Dialog Component", "Get all Vendors Failed");
                                                }
                                            );

                                        } else
                                            if (name == "Party Ledger") {


                                                let requestData = {
                                                    customer: defaultValueObject && defaultValueObject.entityIds ? defaultValueObject.entityIds : [],
                                                    fleetOwnerId: user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                                                    getCustomersOnlyWithBalance: false,
                                                    getTripsOnlyWithBalance: false,
                                                    startDateRange: dateFilterValues[defaultValueObject && defaultValueObject.dateFilterStatus ? defaultValueObject.dateFilterStatus : "ALL_MONTHS"]["startDateRange"],
                                                    status: TRIP_FILTER_STATUS_MAPPING[defaultValueObject && defaultValueObject.tripStatusFilter ? defaultValueObject.tripStatusFilter : "ACTIVE"],
                                                    defaultStatus: false
                                                }

                                                if (defaultValueObject && defaultValueObject.customDateRange && defaultValueObject.customDateRange.startTimeEpoch) {
                                                    requestData.startDateRange = {
                                                        startTimeEpoch: defaultValueObject.customDateRange.startTimeEpoch,
                                                        endTimeEpoch: defaultValueObject.customDateRange.endTimeEpoch
                                                    }
                                                }



                                                dispatchGetAllParties({},
                                                    (data) => {
                                                        if (data && data.status && data.status.code == 200) {
                                                            logger.log("Reports Dialog Dweb", "Get all Parties successfull");
                                                            dispatchGetPartyLedgerPdf(requestData,
                                                                (data) => {
                                                                    setShowTripStatusFilter(true);
                                                                    if (data && data.status && data.status.code == 200) {
                                                                        logger.log('Reports Dialog Dweb', 'Get Supplier Ledger Report Pdf Successfull');
                                                                        if (data && data.response && data.response.pdfId) {
                                                                            const pdfData = {
                                                                                "pdfId": data.response.pdfId
                                                                            }
                                                                            dispatchPartyLedgerPdfDownload(pdfData,
                                                                                (data) => {
                                                                                    if (data && data.status && data.status.code == 200) {
                                                                                        trackDwebEvent("Dweb Party Balance Report", {});
                                                                                        logger.log('Reports Dialog Dweb', 'Get Supplier Ledger Report S3 Link Successfull');
                                                                                    }
                                                                                },
                                                                                () => {
                                                                                    logger.log('Reports Dialog Dweb', 'Get Supplier Ledger Report S3 Link failed');
                                                                                }
                                                                            )
                                                                        }
                                                                    }
                                                                },
                                                                () => {
                                                                    logger.log('Reports Dialog Dweb', 'Get Supplier Ledger Report Pdf Failed');
                                                                    setShowTripStatusFilter(true);
                                                                    setTripStatus("ACTIVE");
                                                                }
                                                            )
                                                        }
                                                    },
                                                    () => {
                                                        logger.log("Reports Dialog Dweb", "Get all Parties failed");
                                                    }
                                                )

                                            } else if (name == "Invoice Preview") {

                                                dispatchGetInvoicePdf(invoiceId,
                                                    (data) => {
                                                        if (data && data.status && data.status.code == 200) {
                                                            logger.log('Reports Dialog Dweb', 'Get Single Invoice Pdf Successfull');
                                                        }
                                                    },
                                                    () => {
                                                        logger.log('Reports Dialog Dweb', 'Get Single Invoice Pdf Failed');
                                                    }
                                                )

                                                } else if (name == "Driver Khata") {

                                                    dispatchGetSingleDriverKhatPdf(driverIdFromSingleDriver,
                                                        (data) => {
                                                            if (data && data.status && data.status.code == 200) {
                                                                logger.log('Reports Dialog Dweb', 'Get Single Driver Khata Pdf Successfull');
                                                            }
                                                        },
                                                        () => {
                                                            logger.log('Reports Dialog Dweb', 'Get Single Driver Khata Pdf Failed');
                                                        }
                                                    )

                                                } else if (name == "Shop Khata") {

                                                    dispatchGetSingleShopKhataPdf(shopIdFromSingleShop,
                                                        (data) => {
                                                            if (data && data.status && data.status.code == 200) {
                                                                logger.log('Reports Dialog Dweb', 'Get Single Shop Khata Pdf Successfull');
                                                            }
                                                        },
                                                        () => {
                                                            logger.log('Reports Dialog Dweb', 'Get Single Shop Khata Pdf Failed');
                                                        }
                                                    )

                                                }

    }, [open]);
    // *********************************************************************


    // ****************************** Setting PDF APIs response into state variable ******************************
    useEffect(() => {

        if (focusPdf.current) {
            focusPdf.current.focus();
        }
        if (name == "Export Party Ledger Report" || name == "Monthly Balance Tab" || fromPartyIncomeReport) {
            setReportData(user.singlePartyPDFReport)
        } else if (name == "Export Supplier Ledger Report") {
            setReportData(user.singleVendorPDFReport)
        } else if (name == "Trip Profit & Loss Report") {
            setReportData(vehicle.tripPNLMonthlyPDF)
        } else if (name == "Document Book") {
            setReportData(vehicle.documentPDF)
        } else if (name == "Truck Monthly Profit & Loss") {
            setReportData(vehicle.profitLossMonthlyPDF);
        } else if (name == "Trip Bill") {
            setReportData(trip.tripPdfData)
        } else if (name == "Truck Monthly Profit and Loss Report") {
            setReportData(vehicle.vehicleMonthlyPnlPdfLink);
        } else if (name == "Profit and Loss Report") {
            setReportData(user.profitLossReportPdfS3)
        } else if (name == "Supplier Ledger") {
            setReportData(user.supplierLedgerPdfS3)
        } else if (name == "Party Ledger") {
            setReportData(user.partyLedgerPdfS3)
        } else if (name == "Invoice Preview") {
            setReportData(trip.singleInvoicePdf);
        } else if (name == "Driver Khata") {
            setReportData(vehicle.singleDriverKhataPdf);
        } else if(name == "Shop Khata") {
            setReportData(user.singleShopKhataPdf)
        }

    }, [focusPdf, open, user.monthlyPNLWise, user.singlePartyPDFReport, user.singleVendorPDFReport, vehicle.tripPNLMonthlyPDF, vehicle.documentPDF, vehicle.profitLossMonthlyPDF, trip.tripPdfData, user.profitLossReportPdfS3, user.supplierLedgerPdfS3, user.partyLedgerPdfS3, trip.singleInvoicePdf]);
    // *******************************************************************


    // ***************************************** Recalling respective PDF APIs when PDF filters change *****************************************
    useEffect(() => {

        if ((name == "Export Party Ledger Report" || fromPartyIncomeReport) && changeDataFlag) {
            let requestData = {
                customer: customer.length > 0 ? customer : [],
                fleetOwnerId: user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                getCustomersOnlyWithBalance: false,
                getTripsOnlyWithBalance: false,
                startDateRange: dateFilterValues[dateFilterValue]["startDateRange"],
                status: TRIP_FILTER_STATUS_MAPPING[tripStatus]
            }

            if (fromSinglePartyPage) {
                requestData.customer = [Number(partyIdFromSingleParty)];
                requestData.defaultStatus = false
            }

            if (fromPartyIncomeReport) {
                requestData.customer = [Number(partyIdFromPartyIncomeReport)];
                if (dateValue && dateValue.startTimeEpoch && dateValue.endTimeEpoch) {
                    requestData.defaultStatus = false
                    requestData.startDateRange = dateValue;
                }
                else {
                    if (pdfMonth) {
                        const filterValue = getEpochForSpecificMonth(pdfMonth);
                        requestData.startDateRange = filterValue
                    }
                }
            }

            if (customFilterValue && customFilterValue.startTimeEpoch) {
                requestData.startDateRange = {
                    startTimeEpoch: customFilterValue.startTimeEpoch,
                    endTimeEpoch: customFilterValue.endTimeEpoch
                }
            }

            dispatchGetSinglePartyPDFReportAction(
                requestData,
                () => {
                    logger.log("Reports Dialog Dweb", "Get Single Party PDF Successfull");
                },
                () => {
                    logger.log("Reports Dialog Dweb", "Get Single Party PDF Failed");
                }
            )

        } else if (name == "Export Supplier Ledger Report" && changeDataFlag) {
            let requestData = {
                vendors: customer.length > 0 ? customer : [],
                fleetOwnerId: user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                startDateRange: dateFilterValues[dateFilterValue]["startDateRange"],
                status: TRIP_FILTER_STATUS_MAPPING[tripStatus],
            }

            if (fromSingleSupplierPage) {
                requestData.vendors = [Number(vendorIdFromSingleSupplier)];
                requestData.defaultStatus = false;
            }

            if (customFilterValue && customFilterValue.startTimeEpoch) {
                requestData.startDateRange = {
                    startTimeEpoch: customFilterValue.startTimeEpoch,
                    endTimeEpoch: customFilterValue.endTimeEpoch
                }
            }

            dispatchGetSingleVendorPDFReportAction(
                requestData,
                () => {
                    logger.log("Reports Dialog Component", "Get single vendor pdf successfull");
                },
                () => {
                    logger.log("Reports Dialog Component", "Get single vendor pdf failed");
                }
            );
        } else if (name == "Monthly Balance Tab" && changeDataFlag) {
            let requestData = {
                customer: partyIdFromSingleParty ? [Number(partyIdFromSingleParty)] : "",
                fleetOwnerId: user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                getCustomersOnlyWithBalance: false,
                getTripsOnlyWithBalance: false,
                startDateRange: startDateRange,
                status: TRIP_FILTER_STATUS_MAPPING[tripStatus],
                defaultStatus: false
            }

            dispatchGetSinglePartyPDFReportAction(
                requestData,
                () => {
                    logger.log("Reports Dialog Dweb", "Get Single Party PDF Successfull");
                },
                () => {
                    logger.log("Reports Dialog Dweb", "Get Single Party PDF Failed");
                }
            )

        } else if (name == "Trip Profit & Loss Report" && changeDataFlag) {
            dispatchTripBookPdf({
                vehicleId: Number(vehicleIdValue),
                month: dateValue
            },
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Reports Dialog Component Dweb", "Get Trip Book successfull");
                    }
                },
                () => {
                    logger.log("Reports Dialog Component Dweb", "Get Trip Book failed");
                }
            )
        } else
            if (name == "Document Book" && changeDataFlag) {
                dispatchGetDocumentsPDF({
                    vehicleId: Number(vehicleIdValue),
                    documentTypes: documentFilterKeyValue == 'all_document' ? [] : [documentFilterKeyValue]
                },
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            trackDwebEvent("Dweb SVP Document PDF Initiated", {
                                vehicle_id: vehicleIdValue,
                                vehicle_number: singleTruck.vehicleNumber ? singleTruck.vehicleNumber : "",
                                count_of_document_types: data && data.response && data.response.reportData && data.response.reportData.documents && data.response.reportData.documents.length > 0 ? data.response.reportData.documents.length : 0
                            });
                            if (data && data.response && data.response.reportData && data.response.reportData.documents && data.response.reportData.documents.length > 0) {
                                setDocCount(data.response.reportData.documents.length);
                            } else {
                                setDocCount(0);
                            }
                            logger.log("Reports Dialog Component Dweb", 'Document PDF Fetch Successfull');
                        }
                    },
                    () => {
                        logger.log("Reports Dialog Component Dweb", 'Document PDF Fetch Failed');
                    });
            } else
                if (name == "Truck Monthly Profit & Loss" && changeDataFlag) {

                    let requestData = {
                        vehicleId: vehicleIdValue,
                        month: dateValue ? dateValue : ""
                    }

                    dispatchGetMonthlyProfitLossPDF(requestData,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log("Reports Dialog Component Dweb", 'Get truck Monthly PandL successfull');
                            }
                        },
                        () => {
                            logger.log("Reports Dialog Component Dweb", 'Get truck Monthly PandL failed');
                        }
                    );

                } else
                    if (name == "Truck Monthly Profit and Loss Report" && changeDataFlag) {
                        const filterData = {
                            "month_year": dateValue ? dateValue : ""
                        }

                        dispatchGetTruckMonthlyPnlV2(vehicleIdValue, filterData,
                            (data) => {
                                if (data && data.status && data.status.code == 200) {
                                    logger.log("Reports Dialog Dweb", "Get Truck Monthly PNL V2 successfull");
                                    if (data && data.response && data.response.pdfId) {
                                        const pdfData = {
                                            pdfId: data.response.pdfId
                                        }
                                        dispatchVehcileMonthlyPnlReportPdf(vehicleIdValue, pdfData,
                                            () => {
                                                logger.log("Reports Dialog Dweb", "Pdf link fetched successfull");
                                            },
                                            () => {
                                                logger.log("Reports Dialog Dweb", "Pdf link fetched failed");
                                            }
                                        );
                                    }
                                }
                            },
                            () => {
                                logger.log("Reports Dialog Dweb", "Get Truck Monthly PNL V2 failed");
                            }
                        )

                    } else
                        if (name == "Profit and Loss Report" && changeDataFlag) {

                            const filterData = {
                                "month_year": dateValue ? dateValue : ""
                            };
                            dispatchGetPnlPdf(filterData,
                                (data) => {
                                    if (data && data.status && data.status.code == 200) {
                                        logger.log('Reports Dialog Dweb', 'Get Profit Loss Report Pdf Successfull');
                                        if (data && data.response && data.response.pdfId) {
                                            const pdfData = {
                                                "pdfId": data.response.pdfId
                                            }
                                            dispatchProfiLossReportDownload(pdfData,
                                                (data) => {
                                                    if (data && data.status && data.status.code == 200) {
                                                        logger.log('Reports Dialog Dweb', 'Get Profit Loss Report S3 Link Successfull');
                                                    }
                                                },
                                                () => {
                                                    logger.log('Reports Dialog Dweb', 'Get Profit Loss Report S3 Link failed');
                                                }
                                            )
                                        }
                                    }
                                },
                                () => {
                                    logger.log('Reports Dialog Dweb', 'Get Profit Loss Report Pdf Successfull');
                                }
                            );

                        } else
                            if (name == "Supplier Ledger" && changeDataFlag) {
                                let requestData = {
                                    vendors: customer.length > 0 ? customer : [],
                                    fleetOwnerId: user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                                    startDateRange: dateFilterValues[dateFilterValue]["startDateRange"],
                                    status: TRIP_FILTER_STATUS_MAPPING[tripStatus],
                                }

                                if (customFilterValue && customFilterValue.startTimeEpoch) {
                                    requestData.startDateRange = {
                                        startTimeEpoch: customFilterValue.startTimeEpoch,
                                        endTimeEpoch: customFilterValue.endTimeEpoch
                                    }
                                }

                                dispatchGetSupplierLedgerPdf(requestData,
                                    (data) => {
                                        if (data && data.status && data.status.code == 200) {
                                            logger.log('Reports Dialog Dweb', 'Get Supplier Ledger Report Pdf Successfull');
                                            if (data && data.response && data.response.pdfId) {
                                                const pdfData = {
                                                    "pdfId": data.response.pdfId
                                                }
                                                dispatchSupplierLedgerPdfDownload(pdfData,
                                                    (data) => {
                                                        if (data && data.status && data.status.code == 200) {
                                                            logger.log('Reports Dialog Dweb', 'Get Supplier Ledger Report S3 Link Successfull');
                                                        }
                                                    },
                                                    () => {
                                                        logger.log('Reports Dialog Dweb', 'Get Supplier Ledger Report S3 Link failed');
                                                    }
                                                )
                                            }
                                        }
                                    },
                                    () => {

                                    }
                                )
                            } else
                                if (name == "Party Ledger" && changeDataFlag) {

                                    let requestData = {
                                        customer: customer.length > 0 ? customer : [],
                                        fleetOwnerId: user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                                        getCustomersOnlyWithBalance: false,
                                        getTripsOnlyWithBalance: false,
                                        startDateRange: dateFilterValues[dateFilterValue]["startDateRange"],
                                        status: TRIP_FILTER_STATUS_MAPPING[tripStatus]
                                    }

                                    if (customFilterValue && customFilterValue.startTimeEpoch) {
                                        requestData.startDateRange = {
                                            startTimeEpoch: customFilterValue.startTimeEpoch,
                                            endTimeEpoch: customFilterValue.endTimeEpoch
                                        }
                                    }

                                    dispatchGetPartyLedgerPdf(requestData,
                                        (data) => {
                                            if (data && data.status && data.status.code == 200) {
                                                logger.log('Reports Dialog Dweb', 'Get Supplier Ledger Report Pdf Successfull');
                                                if (data && data.response && data.response.pdfId) {
                                                    const pdfData = {
                                                        "pdfId": data.response.pdfId
                                                    }
                                                    dispatchPartyLedgerPdfDownload(pdfData,
                                                        (data) => {
                                                            if (data && data.status && data.status.code == 200) {
                                                                logger.log('Reports Dialog Dweb', 'Get Supplier Ledger Report S3 Link Successfull');
                                                            }
                                                        },
                                                        () => {
                                                            logger.log('Reports Dialog Dweb', 'Get Supplier Ledger Report S3 Link failed');
                                                        }
                                                    )
                                                }
                                            }
                                        },
                                        () => {
                                            logger.log('Reports Dialog Dweb', 'Get Supplier Ledger Report Pdf Failed');
                                        }
                                    )
                                }

    }, [dateValue, tripStatus, customer, dateFilterValue, startDateRange, documentFilterKeyValue, customFilterValue])
    // *****************************************


    // ***************************************** Assigning report dialog CSS to variable *****************************************
    const classes = reportsDialogCss();
    // *****************************************


    // **************************************** Triggered when report dialog closed ****************************************
    const handleClose = () => {
        dispatchChatView(true)
        setDialogOpen(false);
        onClose();
        setReportData({});
        if (name == "Export Party Ledger Report" || fromPartyIncomeReport) {
            user.singlePartyPDFReport = {}
        } else if (name == "Export Supplier Ledger Report") {
            user.singleVendorPDFReport = {}
        } else if (name == "Trip Profit & Loss Report") {
            vehicle.tripPNLMonthlyPDF = {}
        } else if (name == "Truck Monthly Profit & Loss") {
            vehicle.profitLossMonthlyPDF = {}
        } else if (name == "Trip Bill") {
            trip.tripPdfData = {}
        } else if (name == "Truck Monthly Profit and Loss Report") {
            vehicle.vehicleMonthlyPnlPdfLink = {}
        } else if (name == "Profit and Loss Report") {
            user.profitLossReportPdf = {}
            user.profitLossReportPdfS3 = {}
        } else if (name == "Supplier Ledger") {
            user.supplierLedgerPdfV2 = {}
            user.supplierLedgerPdfS3 = {}
        } else if (name == "Party Ledger") {
            user.partyLedgerPdfV2 = {}
            user.partyLedgerPdfS3 = {}
        } else if (name == "Invoice Preview") {
            trip.singleInvoicePdf = {}
        } else if (name == "Driver Khata") {
            vehicle.singleDriverKhataPdf = {}
        }
    }
    // *************************************************


    const handlePnlDate = (dateValueFromDateFilter) => {
        setDateValue(dateValueFromDateFilter);
        setChangeDataFlag(true);
    }

    // const handleDatePDFFilterClickOpen = () => {
    //     setPdfFilterOpen(true);
    // }

    const handleTripStatus = (value) => {
        setTripStatus(value);
        setChangeDataFlag(true);
    }

    const handleDateValue = (dateValue) => {
        if (dateValue == "CUSTOM") {
            setCustomFilter(true);
        }
        else {
            setDateFilterValue(dateValue);
            setCustomFilter(false);
            setCustomFilterValue({});
        }
        setChangeDataFlag(true);
    }

    // pdf related settings
    function onDocumentLoadSuccess({ numPages: nextNumPages }) {
        let header = document.getElementsByTagName('header')[0];
        if (header) {
            setPdfWidth(header.clientWidth - 60);
        }
        setNumPages(nextNumPages);
        // setNumPages(3);
    }

    const handleCheck = (value) => {
        setCustomer(value);
        setChangeDataFlag(true);
    }

    // Handling View Report from Single party monthly balance
    const handleMonthlyBalanceDate = (value) => {
        setDateValue(value);
        let dateValue = getDateFilterValueForMonthlyBalance(value);
        setStartDateRange(dateValue.startDateRange);
        setChangeDataFlag(true);

    }

    // ******************************************* Tracking Events when download button is clicked *******************************************
    const handleDownloadClick = () => {
        if (vendorIdFromSingleSupplier && name == "Export Supplier Ledger Report") {
            trackDwebEvent("Dweb Single Suppler PDF", {
                "supplier_id": vendorIdFromSingleSupplier,
                "supplier_name": pageTitleValue
            })
        } else if (name == "Export Party Ledger Report") {
            trackDwebEvent("Dweb Profile Party PDF Download", {});
        } else if (name == "Export Supplier Ledger Report") {
            trackDwebEvent("Dweb Profile Supplier PDF Download", {});
        } else if (name == "Trip Profit & Loss Report") {
            trackDwebEvent("Dweb SVP Trip Book PDF Downloaded", {
                vehicle_id: singleTruck && singleTruck.id ? singleTruck.id : "",
                vehicle_number: singleTruck && singleTruck.vehicleNumber ? singleTruck.vehicleNumber : ""
            })
        } else if (name == "Document Book") {
            trackDwebEvent("Dweb SVP Document PDF Downloaded", {
                vehicle_id: singleTruck && singleTruck.id ? singleTruck.id : "",
                vehicle_number: singleTruck && singleTruck.vehicleNumber ? singleTruck.vehicleNumber : "",
                count_of_document_types: docCount
            });
        } else if (name == "Profit and Loss Report") {
            trackDwebEvent("Dweb Profit and Loss Report PDF Download", {
                default_month: dateValue ? dateValue : pdfMonth
            })
        } else if (name == "Party Ledger") {
            trackDwebEvent("Dweb Party Balance Report PDF Download", {});
        } else if (name == "Supplier Ledger") {
            trackDwebEvent("Dweb Supplier Balance Report PDF Download", {})
        } else if (name == "Invoice Preview") {
            const singleInvoiceData = trip && trip.singleInvoiceInfo ? trip.singleInvoiceInfo : {}
            trackDwebEvent("Dweb Invoice downloaded", {
                party_name: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.customerName ? singleInvoiceData.invoiceDetails.customerName : "",
                party_id: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.customerId ? singleInvoiceData.invoiceDetails.customerId : "",
                count_of_trips: singleInvoiceData && singleInvoiceData.trips ? singleInvoiceData.trips.length : 0,
                total_invoice_amount: singleInvoiceData && singleInvoiceData.amounts && singleInvoiceData.amounts.total ? singleInvoiceData.amounts.total : "",
                invoice_number: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.invoiceNumber ? singleInvoiceData.invoiceDetails.invoiceNumber : "",
                invoice_date: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.invoiceDate ? getMilliDatePickerDateInStringDDMMMYYYY(singleInvoiceData.invoiceDetails.invoiceDate) : "",
                due_days: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.dueIn ? singleInvoiceData.invoiceDetails.dueIn : "",
                invoice_id: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.id ? singleInvoiceData.invoiceDetails.id : ""
            })
        }
    }
    // *******************************************


    const handleDocFilterSelect = (value) => {
        setDocumentFilterKeyValue(value);
        setChangeDataFlag(true);
    }

    const handleCustomFilterClose = () => {
        setCustomFilter(false);
    }

    const handleCustomFilterConfirm = (value) => {
        setDateFilterValue("CUSTOM");
        setCustomFilter(false);
        setCustomFilterValue(value);
    }

    // ******************************************* Triggered when downloading excel for respective flows *******************************************
    const handleExcelDownload = () => {
        let monthYear;
        if (dateValue) {
            monthYear = dateValue;
        } else {
            monthYear = pdfMonth;
        }

        if (name == "Truck Monthly Profit and Loss Report") {
            dispatchGetTruckIncomeExcel(monthYear,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Reports Dialog Dweb", "Get Excel link successfull");
                        if (data && data.response && data.response.s3Link) {
                            window.open(data.response.s3Link);
                            trackDwebEvent("Dweb Truck Monthly Profit and Loss Report Excel Download", {});
                        }
                    }
                },
                () => {
                    logger.log("Reports Dialog Dweb", "Get Excel link failed");
                }
            )
        } else if (name == "Profit and Loss Report") {

            dispatchDownloadPnlExcel(monthYear,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('Reports Dialog Dweb', 'Download Pnl Excel Successfull');
                        if (data && data.response && data.response.s3Link) {
                            trackDwebEvent("Dweb Profit and Loss Report Excel Download", {
                                default_month: monthYear
                            });
                            window.open(data.response.s3Link)
                        }
                    }
                },
                () => {
                    logger.log('Reports Dialog Dweb', 'Download Pnl Excel Failed');
                }
            )

        } else if (name == "Party Ledger" || fromPartyIncomeReport) {

            let requestData = {
                customer: customer.length > 0 ? customer : [],
                fleetOwnerId: user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                getCustomersOnlyWithBalance: false,
                getTripsOnlyWithBalance: false,
                startDateRange: dateFilterValues[dateFilterValue]["startDateRange"],
                status: TRIP_FILTER_STATUS_MAPPING[tripStatus],
            }


            if (customFilterValue && customFilterValue.startTimeEpoch) {
                requestData.startDateRange = {
                    startTimeEpoch: customFilterValue.startTimeEpoch,
                    endTimeEpoch: customFilterValue.endTimeEpoch
                }
            }

            if (fromPartyIncomeReport) {
                requestData.customer = [Number(partyIdFromPartyIncomeReport)];
                if (dateValue && dateValue.startTimeEpoch && dateValue.endTimeEpoch) {
                    requestData.customer = [Number(partyIdFromPartyIncomeReport)];
                    requestData.startDateRange = dateValue;
                } else if (pdfMonth) {
                    const filterValue = getEpochForSpecificMonth(pdfMonth);
                    requestData.startDateRange = filterValue
                }

                if (!changeDataFlag) {
                    requestData.defaultStatus = true;
                }
            }


            // ********************************** Changing the request data if Default Data is present **********************************
            if (defaultValueObject && (defaultValueObject.dateFilterStatus || defaultValueObject.customDateRange) && defaultValueObject.tripStatusFilter) {

                requestData.startDateRange = dateFilterValues[defaultValueObject && defaultValueObject.dateFilterStatus ? defaultValueObject.dateFilterStatus : "ALL_MONTHS"]["startDateRange"];
                requestData.status = TRIP_FILTER_STATUS_MAPPING[defaultValueObject && defaultValueObject.tripStatusFilter ? defaultValueObject.tripStatusFilter : "ACTIVE"];
                requestData.customer = defaultValueObject && defaultValueObject.entityIds ? defaultValueObject.entityIds : [];

                if (defaultValueObject.customDateRange && defaultValueObject.customDateRange.startTimeEpoch) {
                    requestData.startDateRange = {
                        startTimeEpoch: defaultValueObject.customDateRange.startTimeEpoch,
                        endTimeEpoch: defaultValueObject.customDateRange.endTimeEpoch
                    }
                }

            }


            dispatchPartyBalanceExcel(requestData,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('Reports Dialog Dweb', 'Party Balance Report Get Excel Successfull');
                        if (data && data.response && data.response.s3Link) {
                            trackDwebEvent("Dweb Party Balance Report Excel Download", {});
                            window.open(data.response.s3Link);
                        }
                    }
                },
                () => {
                    logger.log('Reports Dialog Dweb', 'Party Balance Report Get Excel Failed');
                }
            );

        } else if (name == "Supplier Ledger") {

            let requestData = {
                vendors: customer.length > 0 ? customer : [],
                fleetOwnerId: user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
                startDateRange: dateFilterValues[dateFilterValue]["startDateRange"],
                status: TRIP_FILTER_STATUS_MAPPING[tripStatus],
            }

            if (customFilterValue && customFilterValue.startTimeEpoch) {
                requestData.startDateRange = {
                    startTimeEpoch: customFilterValue.startTimeEpoch,
                    endTimeEpoch: customFilterValue.endTimeEpoch
                }
            }

            // ********************************** Changing the request data if Default Data is present **********************************
            if (defaultValueObject && (defaultValueObject.dateFilterStatus || defaultValueObject.customDateRange) && defaultValueObject.tripStatusFilter) {

                requestData.startDateRange = dateFilterValues[defaultValueObject && defaultValueObject.dateFilterStatus ? defaultValueObject.dateFilterStatus : "ALL_MONTHS"]["startDateRange"];
                requestData.status = TRIP_FILTER_STATUS_MAPPING[defaultValueObject && defaultValueObject.tripStatusFilter ? defaultValueObject.tripStatusFilter : "ACTIVE"];
                requestData.vendors = defaultValueObject && defaultValueObject.entityIds ? defaultValueObject.entityIds : [];

                if (defaultValueObject.customDateRange && defaultValueObject.customDateRange.startTimeEpoch) {
                    requestData.startDateRange = {
                        startTimeEpoch: defaultValueObject.customDateRange.startTimeEpoch,
                        endTimeEpoch: defaultValueObject.customDateRange.endTimeEpoch
                    }
                }

            }

            dispatchSupplierBalanceExcel(requestData,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('Reports Dialog Dweb', 'Supplier Balance Report Get Excel Successfull');
                        if (data && data.response && data.response.s3Link) {
                            trackDwebEvent("Dweb Supplier Balance Report Excel Download", {});
                            window.open(data.response.s3Link);
                        }
                    }
                },
                () => {
                    logger.log('Reports Dialog Dweb', 'Supplier Balance Report Get Excel Failed');
                }
            )

        }
    }
    // ********************************************

    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='xl'
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogOpen} classes={{ paperScrollPaper: classes.paper1, paperWidthXl: fromDocumentBook ? classes.paperWidth : "" }} >
                <DialogTitle id="add-party-dialog-title" onClose={handleClose} className={classes.dialogTitleV1}>
                    <span>
                        <span className={classes.fwV1}>{name == "Monthly Balance Tab" ? "Export Party Ledger Report" : name}</span>
                        {fromDocumentBook &&
                            <>
                                {vehicleNumberValue &&
                                    <span className={classes.vehicleNumber}> {vehicleNumberValue.vehicleNumberPrefix} < span className={classes.vehicleNumberSuffix}> {vehicleNumberValue.vehicleNumberSuffix}</span></span>
                                }
                                {truckType &&
                                    <>
                                        <span className={classes.bullet}>â€¢</span>
                                        <span className={classes.truckType}>{truckType}</span>
                                    </>
                                }
                            </>
                        }
                        {name == "Truck Monthly Profit and Loss Report" &&
                            <>
                                <span className={classes.mlV2}>
                                    {vehicleNumberValue && vehicleNumberValue.map((vehicleNumber) => (
                                        <span className={classes.vehicleNumberReport}> {vehicleNumber}</span>
                                    ))}
                                </span>
                            </>
                        }
                    </span>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent className={classes.dialogContentV1}>
                    {(name == "Trip Profit & Loss Report" || name == "Truck Monthly Profit & Loss" || name == "Truck Monthly Profit and Loss Report" || name == "Profit and Loss Report") &&
                        <div className={classes.mtV1}>
                            <FilterComponent reportType={name} pnlDate={handlePnlDate} defaultValue={pdfMonth} />
                        </div>
                    }

                    {name == "Monthly Balance Tab" &&
                        <div className={classes.divV1}>
                            <FilterComponent reportType={name} monthlyDate={handleMonthlyBalanceDate} fromMonthlyBalance={true} monthlyDateValue={monthDate} />
                            <span className={classes.mlV1}>
                                <TripStatusFilter status={handleTripStatus} fromReportsDialog={true} defaultTripStatusFilter={tripStatus} />
                            </span>
                        </div>
                    }

                    {fromPartyIncomeReport &&
                        <div className={classes.divAlign}>
                            <span >
                                {/* <DateFilter dateValue={handleDateValue} fromReportsDialog={true} /> */}
                                <FilterComponent pnlDate={handlePnlDate} defaultValue={pdfMonth} fromPartyIncomeReport={true} />
                            </span>
                            <span className={classes.mlV1}>
                                <TripStatusFilter status={handleTripStatus} fromReportsDialog={true} defaultTripStatusFilter={tripStatus} />
                            </span>
                        </div>
                    }

                    {(name == "Export Party Ledger Report" || name == "Export Supplier Ledger Report") &&
                        <div className={classes.mtV1}>
                            {showTripStatusFilter &&
                                <span>
                                    <TripStatusFilter status={handleTripStatus} fromReportsDialog={true} defaultTripStatusFilter={tripStatus} />
                                </span>
                            }
                            <span className={classes.mlV1}>
                                <DateFilter dateValue={handleDateValue} fromReportsDialog={true} />
                            </span>

                            {(name == "Export Party Ledger Report" && !fromSinglePartyPage) &&
                                <span className={classes.mlV1}>
                                    <PartySupplierFilter type={"party"} onCheck={handleCheck} />
                                </span>
                            }

                            {(name == "Export Supplier Ledger Report" && !fromSingleSupplierPage) &&
                                <span className={classes.mlV1}>
                                    <PartySupplierFilter type={"supplier"} onCheck={handleCheck} />
                                </span>
                            }

                        </div>
                    }

                    {/* {(name == "Supplier Ledger" || name == "Party Ledger") &&
                        <div className={classes.mtV1}>
                            <span>
                                <DateFilter dateValue={handleDateValue} fromReportsDialog={true} defaultValue={defaultValueObject && defaultValueObject.dateFilterStatus ? defaultValueObject.dateFilterStatus : ""} />
                            </span>

                            {showTripStatusFilter &&
                                <span className={classes.mlV1}>
                                    <TripStatusFilter status={handleTripStatus} fromReportsDialog={true} defaultTripStatusFilter={tripStatus} />
                                </span>
                            }

                            {name == "Supplier Ledger" &&
                                <span className={classes.mlV1}>
                                    <PartySupplierFilter type={"supplier"} onCheck={handleCheck} defaultValue={defaultValueObject && defaultValueObject.entityIds ? defaultValueObject.entityIds : []} />
                                </span>
                            }

                            {name == "Party Ledger" &&
                                <span className={classes.mlV1}>
                                    <PartySupplierFilter type={"party"} onCheck={handleCheck} defaultValue={defaultValueObject && defaultValueObject.entityIds ? defaultValueObject.entityIds : []} />
                                </span>
                            }

                        </div>
                    } */}

                    {name == "Document Book" &&
                        <div className={classes.mtV1}>
                            <DocumentBookPdfFilter pdfFilterValueFromReports={pdfFilterValue} defaultFilterValueFromReports={defaultDocumentFilterValueName} onSelect={handleDocFilterSelect} />
                        </div>
                    }

                    {reportData && reportData.s3Link ? (
                        <div className={classes.pdfContainer}>
                            <div className={classes.pdfSubContainer} tabIndex={0} ref={focusPdf} >
                                <SizeMe>
                                    {({ size }) => (
                                        <Document
                                            file={reportData && reportData.s3Link ? reportData.s3Link : null}
                                            onLoadSuccess={onDocumentLoadSuccess}
                                        >

                                            {/* <View style={styles.section}> */}
                                            {/* <Page pageNumber={pageNumber} width={pdfWidth} /> */}
                                            {
                                                Array.from(
                                                    new Array(numPages),
                                                    (el, index) => (
                                                        <Page
                                                            key={`page_${index + 1}`}
                                                            pageNumber={index + 1}
                                                            width={size.width ? size.width : 1}
                                                        />
                                                    ),
                                                )
                                            }
                                            {/* </View> */}

                                        </Document>
                                    )}
                                </SizeMe>
                            </div>
                        </div>
                    ) : (

                        <div className={classes.divV2}>
                            <ImageIcon />
                        </div>
                    )
                    }
                </DialogContent>
                {reportType != "excelReports" &&
                    <DialogActions className={classes.daV1}>
                        <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()} >
                            Close
                        </Button>
                        <a className={classes.anchorV1} href={reportData && reportData.s3Link ? reportData.s3Link : ""} target="_blank" download>
                            <Button className={classes.confirmV1} type="submit" variant="contained" onClick={() => handleDownloadClick()}>
                                Download
                            </Button>
                        </a>
                    </DialogActions>
                }
                {reportType == "excelReports" &&
                    <DialogActions className={classes.daV2}>
                        {!doNotShowExcelButton &&
                            <Button variant="contained" className={classes.excelButton} onClick={() => handleExcelDownload()} >
                                Download Excel
                                <ExcelIconBlack className={classes.mlV2} />
                            </Button>
                        }
                        <a className={classes.anchorV1} href={reportData && reportData.s3Link ? reportData.s3Link : ""} target="_blank" download>
                            <Button className={classes.confirmV1} type="submit" variant="contained" onClick={() => handleDownloadClick()}>
                                Download PDF
                                <PdfIconWhite className={classes.mlV2} />
                            </Button>
                        </a>
                    </DialogActions>
                }
            </Dialog>

            {customFilter && <CustomDateFilterDialog open={customFilter} onClose={handleCustomFilterClose} onConfirm={handleCustomFilterConfirm} />}

        </>
    );

}

const mapStateToProps = (state) => ({ user: state.user, vehicle: state.vehicle, trip: state.trip });
const mapDispatchToProps = (dispatch) => ({
    dispatchGetPnlMonths: (requestData, onSuccess, onFailure) => {
        dispatch(getAllPnlMonths(requestData, onSuccess, onFailure))
    },
    dispatchGetAllParties: (requestData, onSuccess, onFailure) => {
        dispatch(
            getAllParties(
                requestData, onSuccess, onFailure
            )
        )
    },
    dispatchGetSinglePartyPDFReportAction: (requestData, onSuccess, onFailure) => {
        dispatch(
            getSinglePartyPDFReport(
                requestData, onSuccess, onFailure
            )
        )
    },

    dispatchGetAllVendors: (requestData, onSuccess, onFailure) => {
        dispatch(
            getAllVendors(
                requestData, onSuccess, onFailure
            )
        )
    },
    dispatchGetSingleVendorPDFReportAction: (requestData, onSuccess, onFailure) =>
        dispatch(
            getSingleVendorPDFReport(
                requestData, onSuccess, onFailure
            )
        ),

    dispatchGetTripPnlMonths: (data, onSuccess, onFailure) => {
        dispatch(vehicleTripPNLMonthlyList(data, onSuccess, onFailure))
    },
    dispatchTripBookPdf: (data, onSuccess, onFailure) => {
        dispatch(vehicleTripPNLMonthlyPDF(data, onSuccess, onFailure))
    },
    dispatchGetDocumentsPDF: (data, onSuccess, onFailure) => { dispatch(getVehicleDocumentPDF(data, onSuccess, onFailure)) },
    dispatchGetMonthlyProfitLossPDF: (data, onSuccess, onFailure) => {
        dispatch(vehicleMonthlyPnlReportPDF(data, onSuccess, onFailure))
    },
    dispatchGetTripPdf: (tripId, onSuccess, onFailure) => {
        dispatch(getTripPdf(tripId, onSuccess, onFailure))
    },
    dispatchGetTruckMonthlyPnlV2: (vehicleId, filterData, onSuccess, onError) => {
        dispatch(vehcileMonthlyPnlReportV2(vehicleId, filterData, onSuccess, onError))
    },
    dispatchVehcileMonthlyPnlReportPdf: (vehicleId, pdfData, onSuccess, onError) => {
        dispatch(vehcileMonthlyPnlReportPdf(vehicleId, pdfData, onSuccess, onError))
    },
    dispatchGetTruckIncomeExcel: (filterData, onSuccess, onError) => {
        dispatch(truckIncomeExcel(filterData, onSuccess, onError))
    },
    dispatchGetPnlPdf: (filterData, onSuccess, onError) => {
        dispatch(profitLossPdfV2(filterData, onSuccess, onError))
    },
    dispatchProfiLossReportDownload: (pdfData, onSuccess, onError) => {
        dispatch(downloadProfitLossPdfV2(pdfData, onSuccess, onError))
    },
    dispatchDownloadPnlExcel: (monthYear, onSuccess, onError) => {
        dispatch(pnlReportExcel(monthYear, onSuccess, onError))
    },
    dispatchGetSupplierLedgerPdf: (requestData, onSuccess, onError) => {
        dispatch(supplierLegerPdfV2(requestData, onSuccess, onError))
    },
    dispatchSupplierLedgerPdfDownload: (pdfId, onSuccess, onError) => {
        dispatch(supplierLegerPdfDownloadV2(pdfId, onSuccess, onError))
    },
    dispatchGetPartyLedgerPdf: (requestData, onSuccess, onError) => {
        dispatch(partyLegerPdfV2(requestData, onSuccess, onError))
    },
    dispatchPartyLedgerPdfDownload: (pdfId, onSuccess, onError) => {
        dispatch(partyLegerPdfDownloadV2(pdfId, onSuccess, onError))
    },
    dispatchPartyBalanceExcel: (requestData, onSuccess, onError) => {
        dispatch(partyBalanceExcel(requestData, onSuccess, onError))
    },
    dispatchSupplierBalanceExcel: (requestData, onSuccess, onError) => {
        dispatch(supplierBalanceExcel(requestData, onSuccess, onError))
    },
    dispatchGetInvoicePdf: (invoiceId, onSuccess, onError) => {
        dispatch(getInvoicePdf(invoiceId, onSuccess, onError))
    },
    dispatchGetSingleDriverKhatPdf: (driverId, onSuccess, onError) => {
        dispatch(getSingleDriverKhatPdf(driverId, onSuccess, onError))
    },
    dispatchGetSingleShopKhataPdf: (shopId, onSuccess, onError) => {
        dispatch(getSingleShopKhataPdf(shopId, onSuccess, onError))
    },
    dispatchChatView: (value) => dispatch(updateChatView(value)),

});
const ReportsDialogWithRouter = withRouter(ReportsDialog);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportsDialogWithRouter);
